import React, { useState } from "react";
import "./checkBox.css";

const CheckBox = ({ label, onChange }) => {
  const [checked, setChecked] = useState(false);

  const handleChange = (event) => {
    const isChecked = event.target.checked;
    setChecked(isChecked);
    onChange(isChecked);
  };
  return (
    <div className="checkbox_container">
      <input
        type="checkbox"
        className="checkbox_input"
        id="scales"
        name="scales"
        checked={checked}
        onChange={handleChange}
      />
      <div className="checkbox_label boldFont" for="scales">
        {label}
      </div>
    </div>
  );
};

export default CheckBox;
